import { render, staticRenderFns } from "./StructuredValidation.vue?vue&type=template&id=96abde4c&"
import script from "./StructuredValidation.vue?vue&type=script&lang=js&"
export * from "./StructuredValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports